const plugins = [
  "advlist",
  "anchor",
  "autolink",
  "autosave",
  "code",
  "codesample",
  "directionality",
  "emoticons",
  // "fullscreen",
  "image",
  "importcss",
  "insertdatetime",
  "link",
  "lists",
  "media",
  "nonbreaking",
  "pagebreak",
  "preview",
  "save",
  // "searchreplace",
  "table",
  "template",
  "visualblocks",
  "visualchars",
  "wordcount",
  "emoticons",
];
export default plugins;
